export const getUserTriggers = (state) => {
  return state.constructs.user_triggers;
}

export const getUserTriggersOfSelectedDelegate = (payload) => (state) => {

  const { delegate } = payload;
  let userTriggersOfSelectedDelegate = [];

  let user_triggers = getUserTriggers(state);

  user_triggers.forEach(item => {
    const ut = item;
    const event = item.attributes.op;
    const selectedEvent = state.constructs.events.find(item => item.id === event);
    if (selectedEvent?.src === delegate) {

      const field = state.constructs.fields.find(item => {

        const parents = item.parent.map(item => item.id)
        if (parents.includes(ut.id)) return item;

      });

      const transaction = state.constructs.transactions.find(item => {

        const events = item.events.map(item => item.id)
        if (events.includes(selectedEvent.id)) return item;

      });

      const userTrigger = {
        ...item,
        transaction: transaction,
        event: selectedEvent,
        field: field
      }

      userTriggersOfSelectedDelegate.push(userTrigger)
    }

  })

  // const alphabeticallyArrangedList = userTriggersOfSelectedDelegate.sort(function (a, b) {
  //   return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  // })

  // return alphabeticallyArrangedList
  return userTriggersOfSelectedDelegate
}

export const getSelectedUserTrigger = payload => state => {

  const { userTriggerId } = payload;

  const userTrigger = state.constructs.user_triggers.find(item => item.id === userTriggerId)

  const delegate = state.constructs.events.find(item => item.id === userTrigger.attributes.op).src;

  const transaction = state.constructs.transactions.find(item => {

    const events = item.events.map(item => item.id)
    if (events.includes(userTrigger.attributes.op)) return item;

  })

  const field = state.constructs.fields.find(item => {

    const parents = item.parent.map(item => item.id)
    if (parents.includes(userTriggerId)) return item

  })


  const selectedUserTrigger = {
    ...userTrigger,
    transaction: transaction,
    field: field,
    delegate: delegate

  }

  // console.log(selectedUserTrigger)
  return selectedUserTrigger

}

export const getUserTriggersOfSelectedEvent = ({ event }) => ({ constructs }) => {

  let userTriggers = constructs.user_triggers.filter(item => item.attributes.op === event);
  let uts = JSON.parse(JSON.stringify(userTriggers));

  uts.forEach(ut => {
    const event = constructs.events.find(event => event.id === ut.attributes.op);
    const transaction = constructs.transactions.find(item => {
      const events = item.events.map(element => element.id)
      if (events.includes(ut.attributes.op)) return item
    });
    const field = constructs.fields.find(item => {
      const parents = item.parent.map(element => element.id)
      if (parents.includes(ut.id)) return item
    });

    ut.event = event;
    ut.transaction = transaction;
    ut.field = field;
  })

  const alphabeticallyArrangedList = uts.sort(function (a, b) {
    return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
  })

  return alphabeticallyArrangedList;
}

export const getAllUserTriggers = () => (state) => {

  let allUserTriggers = [];

  let user_triggers = getUserTriggers(state);

  user_triggers.forEach(item => {
    const ut = item;
    const event = item.attributes.op;
    const selectedEvent = state.constructs.events.find(item => item.id === event);

    const field = state.constructs.fields.find(item => {
      const parents = item.parent.map(item => item.id)
      if (parents.includes(ut.id)) return item;
    });

    const transaction = state.constructs.transactions.find(item => {
      const events = item.events.map(item => item.id)
      if ( selectedEvent && events.includes(selectedEvent.id)) return item;
    });

    const userTrigger = {
      ...item,
      transaction: transaction,
      event: selectedEvent,
      field: field
    }

    allUserTriggers.push(userTrigger)

  })

  // console.log({allUserTriggers})
  return allUserTriggers

}